import Component from '../core/Component'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'
import { substitute } from '../utils/String'

export const STATES = {
    ACTIVE: 'is-active'
}

const SUPPORTS_CLIP_PATH = window?.CSS?.supports('clip-path', 'initial')

export default class HotelCardAnimation extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            template: null,
            templateTagClosed: null,
            image: null
        }

        this.data = {
            title: '',
            tagClosed: '',
            image: ''
        }

        this.isAnimating = false
        this.swupFinished = false

        this.template = this.ref.template.innerText.trim()
        this.templateTagClosed = this.ref.templateTagClosed.innerText.trim()

        this.cleanupTimerId = null
    }

    prepare() {
        EventBus.on('swup:transitionend', this.handleSwupTransitionEnd)
    }

    destroy() {
        EventBus.off('swup:transitionend', this.handleSwupTransitionEnd)

        if (this.cleanupTimerId) {
            clearTimeout(this.cleanupTimerId)
        }
    }

    handleSwupTransitionEnd = () => {
        this.swupFinished = true
        this.cleanup()
    }

    parse(source) {
        const title = source.querySelector('.hotel-Card-title')
        const tagClosed = source.querySelector('.hotel-TagClosed')
        const image = source.querySelector('img[data-detail]')
        this.data = {
            ...this.data,
            title: title ? title.innerText : '',
            tagClosed: tagClosed ? tagClosed.innerText : '',
            tagClosedHTML: '',
            image,
            src: image ? image.dataset.detail : '',
            element: source
        }

        this.data.tagClosedHTML = this.data.tagClosed ? substitute(this.templateTagClosed, this.data) : ''

        this.element.innerHTML = substitute(this.template, this.data)
    }

    animate() {
        Array.from(this.element.querySelectorAll('img')).forEach(element => element.parentNode.removeChild(element))
        this.element.classList.add(STATES.ACTIVE)

        const targetBox = this.element.querySelector('.hotel-Banner-image').getBoundingClientRect()
        const originBox = this.data.image.getBoundingClientRect()

        return new Promise((resolve, reject) => {

            const image = new Image()
            image.onload = () => {
                image.classList.add('hotel-CardAnimation-image')
                image.style.top = `${targetBox.top}px`
                image.style.left = `${targetBox.left}px`

                const scale = originBox.height/620
                const relativeScale = originBox.height/targetBox.height

                const targetWidth = targetBox.width * relativeScale

                const leftOffset = (targetWidth - originBox.width)/2
                const left = originBox.left - targetBox.left - leftOffset
                const top = originBox.top - targetBox.top

                const x1 = Math.round(leftOffset / targetWidth * 100)
                const x2 = Math.round((leftOffset + originBox.width) / targetWidth * 100)

                if (SUPPORTS_CLIP_PATH) {
                    image.style.clipPath = `polygon(${x1}% 0%, ${x2}% 0%, ${x2}% 100%, ${x1}% 100%)`
                } else {
                    image.style.clip = `rect(0px, ${(leftOffset / relativeScale + originBox.width) / scale}px, ${targetBox.height}px, 0px)`
                }

                image.style.transform = `translate(${left}px,${top}px) scale(${scale})`

                this.element.appendChild(image)
                image.classList.add('is-animated')
                image.offsetWidth

                image.addEventListener(support.transitionEnd, event => {
                    resolve()
                    this.isAnimating = false
                    this.cleanup()
                })

                image.style.transform = `translate(0, 0) scale(${targetBox.width/1280})`
                if (SUPPORTS_CLIP_PATH) {
                    image.style.clipPath = `polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)`
                } else {
                    image.style.clip = `rect(0px, 1280px, 620px, 0px)`
                }
            }

            this.isAnimating = true
            this.swupFinished = false
            image.src = this.data.src
        })
    }

    cleanup() {
        if (this.isAnimating || !this.swupFinished) {
            return
        }

        if (this.cleanupTimerId) {
            clearTimeout(this.cleanupTimerId)
        }

        this.cleanupTimerId = setTimeout(() => {
            this.element.classList.remove(STATES.ACTIVE)
        }, 400)
    }
}
